import { gql } from "@apollo/client";

export const FETCH_TARGET_BADGE = gql`
  query FetchTargetBadge($target_badge_id: ID!) {
    fetchTargetBadge(target_badge_id: $target_badge_id) {
      id
      name
      description
      min_points
      max_points
      cash_equivalent
      minimum_cash_equivalent
      gift_basket {
        gift_name
        gift_type
        gift_image
        gift_description
      }
    }
  }
`;
